<template>
    <header class="head-top">
        <!--登录状态下的头部 isLogin = true -->
        <!--未登录状态下的头部 isLogin = false;-->
        <div class="main-container">
            <img class="logoImg" @click="toMaster" src="../../assets/images/topBar/logo.png"/>
            <div class="head-top-middle">
                建立合作共赢伙伴关系&nbsp;&nbsp;打造公开透明工作方式
            </div>
<!--            <div class="head-right" v-if="!isLogin">-->
<!--                <span class="login" @click="$router.push('/login/masterCenter')">登录</span>-->
<!--                <span class="line"></span>-->
<!--            </div>-->
            <div class="head-right" v-if="isLogin">
                <span class="head-img">
<!--                    <img src="../../assets/images/topBar1/picture.png" alt="" class="headImg">-->
                </span>
                <el-tooltip :disabled="companyName.length < 13" :content="companyName" placement="bottom" effect="light">
                    <span class="register" >{{ companyName }} </span>
                </el-tooltip>
                <span class="line"></span>
                <span class="loginOut" @click="toLoginOut">
                    <i class="iconfont iconguanji"></i>
                    退出
                </span>
            </div>
        </div>
    </header>
</template>

<script type="text/ecmascript-6">
    import Vue from 'vue'
    export default Vue.component('my-header',{
        data () {
            return {
                isLogin:  window.sessionStorage.getItem('refresh_token') ? true : false ,
                companyName: window.sessionStorage.getItem('companyName'),
                headActive: false,
            }
        },
        created(){

        },
        methods: {
            toLoginOut(){
                window.sessionStorage.setItem('token','');
                window.sessionStorage.setItem('refresh_token','');
                let currentUrl = (window.location.href).split('?')[0];
                this.$router.push('/?currentUrl='+encodeURIComponent(currentUrl));
                this.$root.isLogin = false;
            },
            toFirst(){
                this.$root.activeIndex = 'home';
                this.$router.push( '/');
            },
            toSecond(){
                this.$root.activeIndex = 'invite';
                this.$router.push( '/invite-list');
            },
            toThird(){
                this.$root.activeIndex = 'win';
                this.$router.push( '/win-list');
            },
            toFourth(){
                this.$root.activeIndex = 'setting';
                this.$router.push('/help');
            },
            toMaster(){
                this.$root.activeIndex = 'home';
                this.$router.push('/gateway/index');
            }
        },
        mounted(){
            if(this.$route.name == 'index') this.headActive = true;
            window.onhashchange = function(){
                this.hashVal = location.hash.split('/')[1];
                var headerElA = document.getElementsByTagName('header');
                var headerEl = headerElA.length ? headerElA[0] : '';
                var loginRightEl = document.getElementsByClassName('loginRight');
                if( !headerEl ){
                    return;
                }
                if(this.hashVal == 'slide2' || this.hashVal == 'slide3' || this.hashVal == 'slide4'){
                    headerEl.className = 'head-top head-top-bg';
                    if(loginRightEl.length){
                        loginRightEl[0].className = 'loginRight';
                    }
                } else {
                    if(this.hashVal === '' || this.hashVal == 'slide1'){
                        headerEl.className = 'head-top';
                        if(loginRightEl.length){
                            loginRightEl[0].className = 'loginRight loginIndex';
                        }
                    }
                   /* else {
                        headerEl.className = 'head-top head-top-white';
                        if(loginRightEl.length){
                            loginRightEl[0].className = 'loginRight';
                        }
                    }*/
                }
            }
        }
    })

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../../assets/_var.scss';
    .headActive .el-menu-item{
        /*color: #ffffff !important;*/
    }
    .el-breadcrumb {
        height: 44px;
        line-height: 44px;
    }
    .head-top {
        position: absolute;
        left: 0;
        top: 0;
        right: 17px;
        z-index: 9;
        height: 60px;
        width: 100%;
        background: rgba(255,255,255,1);
        // background: rgba(255,255,255,0);
        transition: .5s;
        color: #ececec;

        .head-right .head-img{
            display: inline-block;
            vertical-align: middle;
            // width: 46px;
            // height: 46px;
            box-sizing: border-box;
            width: 36px;
            height: 36px;
            // background-image: url("../../assets/img/home/topBar/headBg.png");
            background-repeat: no-repeat;
            // padding: 2px;
        }

        .head-right .headImg{
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }

        .head-top-middle{
            font-size: 12px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            float: left;
            // margin-left: 100px;
            width: 100%;
        }

        & .line {
            width: 1px;
            height: 12px;
            background: #ececec;
        }
        & .loginRight {
            border-bottom: 1px solid $--secondary-fill-color;
            p {
                text-align: right;
                font-size: 12px;
                color: $--text-color-light;
                line-height: 20px;
                span {
                    display: inline-block;
                    vertical-align: middle;
                }
                span:nth-of-type(odd) {
                    padding-left: 35px;
                    padding-right: 14px;
                    cursor: pointer;
                }
                .backIndex {
                    background: url('../../assets/images/masterCenter/topBar/icon01.png') no-repeat 10px center;
                }
                .helpT {
                    background: url('../../assets/images/masterCenter/topBar/icon02.png') no-repeat 10px center;
                }
                .wechatT {
                    background: url('../../assets/images/masterCenter/topBar/icon03.png') no-repeat 10px center;
                }
                .loginOut {
                    background: url('../../assets/images/masterCenter/topBar/icon04.png') no-repeat 10px center;
                }
                .line {
                    background: $--text-color-light;
                }
            }
        }
        & .loginIndex {
            border-bottom: 1px solid #ececec;
            p {
                color:#ececec;
                .backIndex {
                    background: url('../../assets/images/masterCenter/topBar/icon_01.png') no-repeat 10px center;
                }
                .helpT {
                    background: url('../../assets/images/masterCenter/topBar/icon_02.png') no-repeat 10px center;
                }
                .wechatT {
                    background: url('../../assets/images/masterCenter/topBar/icon_03.png') no-repeat 10px center;
                }
                .loginOut {
                    background: url('../../assets/images/masterCenter/topBar/icon_04.png') no-repeat 10px center;
                }
                .line {
                    background: #ececec;
                }
            }
        }
    }
    .head-top-white {//头部背景为白色
        background: rgba(255,255,255,1);
    }
    .head-top .main-container {
        background: none;
        overflow: hidden;
        background: url("../../assets/images/topBar/bg.png") no-repeat center;
        background-size: 100% auto;
        // background-size: 100% 100%;
    }
    .logoImg {
        left: 0;
        position: absolute;
        vertical-align: middle;
        margin: 14px 270px 0 20px;
        width: 85px;
        cursor: pointer;
    }
    .el-menu {
        float: left;
        vertical-align: middle;
        border: none;
        background: none;
    }
    .head-right {
        position: absolute;
        right: 0;
        margin-top: 10px;
        // float: right;

        vertical-align: middle;
        // color: #fff;
        font-size: 12px;
        margin-right: 20px;
    }
    .head-right span {
        display: inline-block;
        margin: 0 2px;
        vertical-align: middle;
        cursor: pointer;
    }
    .head-right .register {
        max-width: 190px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .login {
        line-height: 28px;
        background: url('../../assets/images/topBar1/icon03.png') no-repeat 0 1px;
        padding-left: 28px;
        padding-right: 5px;
    }
    .register {
        line-height: 28px;
        // background: url('../../assets/images/topBar1/icon04.png') no-repeat 0 1px;
        // padding-left: 26px;
    }
    .head-right .help {
        margin-left: 20px;
        width: 28px;
        height: 28px;
         background: url('../../assets/images/topBar1/icon01.png') no-repeat;
     }
    .wechat {
        width: 28px;
        height: 28px;
        background: url('../../assets/images/topBar1/icon02.png') no-repeat;
    }
    .el-menu--horizontal > .el-menu-item {
        color: $--text-color;
        height: 58px;
    }
    .el-menu--horizontal > .el-menu-item.is-active {
        font-weight: 700;
        color: $--text-color;
        background: none;
     }
    .el-menu--horizontal .el-menu-item:hover, .el-menu--horizontal .el-menu-item:focus {
        color: $--text-color;
        background: none;
    }
    .head-top-bg {
        position: fixed;
        /*height: 60px;*/
        background: rgba(255, 255, 255, .8);
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
    }
    .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover {
        background: none;
        /*color: #fff;*/
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Header.vue